var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('code',[_vm._v(" "+_vm._s(_vm.comp1))]),_vm._v(" - "),_c('code',[_vm._v(_vm._s(_vm.comp2))]),_vm._v(" - "),_c('code',[_vm._v(_vm._s(_vm.comp3))])])}
var staticRenderFns = []

export { render, staticRenderFns }